/**
 * RequireClienteAuth — guard pra rotas autenticadas /cliente/* (B1.5).
 *
 * Análogo ao RequireAuth do admin, mas usa ClienteAuthContext (cookie
 * httpOnly em vez de Bearer JWT localStorage).
 *
 * Durante isLoading (hidratação inicial): mostra spinner mínimo.
 * Pós-hidratação + sem user: redirect /cliente/login.
 * Com user: renderiza children (Outlet).
 *
 * NÃO REVERTER:
 *   - Loading state mostrado durante hidratação (evita flash de redirect)
 *   - Redirect SEM preservar URL de origem por enquanto (B1.6+ adiciona
 *     suporte a `from` no state)
 */

import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';

import { useClienteAuth } from '@/contexts/ClienteAuthContext';

export function RequireClienteAuth({ children }: { children: ReactNode }) {
  const { isLoading, isAuthenticated } = useClienteAuth();

  if (isLoading) {
    return (
      <div
        className="flex min-h-[60vh] items-center justify-center text-sm text-ink-2 dark:text-ink-dark-2"
        data-testid="cliente-auth-loading"
      >
        Carregando…
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/cliente/login" replace />;
  }

  return <>{children}</>;
}
